import React, { ReactNode } from 'react';
import cx from 'classnames';

type Props = {
  icon: ReactNode;
  title: string;
  className?: string;
};

export default function AssignmentTypeCard(props: Props) {
  const { title, icon, className } = props;

  return (
    <div className={cx(className, 'radio-card-header')}>
      {icon}

      <div className="radio-card-title">{title}</div>
    </div>
  );
}
